var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconChallengeWrite = function SvgIconChallengeWrite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m1.516 13.754-.013 4.003 4.003.013 8.82-8.762-4.042-3.966-8.768 8.712Zm16.214-8.13L15.39 7.95l-4.042-3.965 2.391-2.376a.375.375 0 0 1 .53.002l3.462 3.484a.375.375 0 0 1-.001.53ZM5.863 19.272a.625.625 0 0 0 .443-.181l12.48-12.401c.735-.73.74-1.917.01-2.652L15.333.553a1.875 1.875 0 0 0-2.652-.008l-12.48 12.4a.625.625 0 0 0-.185.442L0 18.627a.625.625 0 0 0 .623.628l5.24.016Zm5.74-1.762a.75.75 0 0 0 0 1.5h9.232a.75.75 0 0 0 0-1.5h-9.232Z",
    fill: "#fff"
  })));
};
export default SvgIconChallengeWrite;